<template>
  <ak-type-input hideLabel v-model="data.status" :field="options" />
</template>
<script>
import Bus from '../../assets/js/eventBus'
export default {
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object // 当前field对象
  },
  data () {
    return {
      filters: {},
      // gdUser: [],
      data: {
        status: ''
      },
      options:
      {
        name: 'status',
        note: '订单状态',
        type: 'Select',
        items: {
          add: '新订订单',
          read: '已读订单',
          madeing: '生产中订单',
          complete: '生产完成订单',
          transit: '运输中订单',
          deliveriesTaked: '已收货订单',
          finish: '已完成订单'
        },
      }
    }
  },
  mounted () {
    Bus.$on('reset', this.reset)
  },
  methods: {
    filterQuery () {
      if (this.data.status) {
        this._value = this.data.status
      } else {
        this._value = 'null'
      }
      // if (this._value) {
      return this._value
      // }
    },
    setValue () {
      this._value = null // 不会报错
    },
    reset (payload) {
      this.data.status = payload
    }
  },
  beforeDestroy () {
    Bus.$off('reset', this.reset)
  },
}
</script>

<style>

</style>
